// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eZXY","newExpiryDate":"styles_newExpiryDate__2oQ5T","footer":"styles_footer__2_TEq"};